import React, { useEffect, useState } from "react";
import { getAuth, updateProfile } from "firebase/auth";
import ProfilePicture from "./ProfilePicture";
import ProfileBio from "./ProfileBio";
import "./ProfilePage.css";

const ProfilePage = () => {
  const auth = getAuth();
  const [user, setUser] = useState(null); // State to hold the user information
  const [editing, setEditing] = useState(false);
  const [newName, setNewName] = useState("");
  const [newBio, setNewBio] = useState("");

  useEffect(() => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      setUser({
        name: currentUser.displayName || "User",
        photo: currentUser.photoURL || "https://via.placeholder.com/150",
        email: currentUser.email || "No bio available",
      });
      setNewBio(currentUser.displayName || "No bio available"); // Initialize the bio with displayName or fallback
    }
  }, [auth]);

  const handleEdit = () => {
    setEditing(true);
    setNewName(user?.name || "");
    setNewBio(user?.email || ""); // Initialize bio for editing
  };

  const handleSave = async () => {
    try {
      const currentUser = auth.currentUser;

      // Update user profile in Firebase
      if (currentUser) {
        await updateProfile(currentUser, {
          displayName: newName,
        });

        // Save bio in your backend if required (Updating the bio)
        setUser({
          ...user,
          name: newName,
          email: newBio, // Update bio with new value
        });
        setEditing(false);
      }
    } catch (error) {
      console.error("Error updating profile:", error.message);
    }
  };

  const handleCancel = () => {
    setEditing(false);
    setNewBio(user?.email || ""); // Reset the bio to original
  };

  const handleSignOut = async () => {
    try {
      await auth.signOut();
      window.location.href = "/auth"; // Redirect to login page
    } catch (error) {
      console.error("Error signing out:", error.message);
    }
  };

  // If the user is not logged in, show the login/signup page
  if (!user) {
    return (
      <div className="profile-page" style={{ backgroundColor: "#e4e1d9" }}>
        <h2>Please log in to access your profile</h2>
        {/* Redirect to login or sign-up page */}
        <button
          className="profile-page-button" // Class name for the buttons
          onClick={() => window.location.href = '/auth/login'}
        >
          Log In
        </button>
        <button
          className="profile-page-button" // Class name for the buttons
          onClick={() => window.location.href = '/auth/signup'}
        >
          Sign Up
        </button>
      </div>
    );
  }

  return (
    <div className="profile-page" style={{ backgroundColor: "#e4e1d9" }}>
      <div className="profile-card" style={{ backgroundColor: "#cfccc7" }}>
        {editing ? (
          <>
            <input
              type="text"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              placeholder="Enter new name"
              style={{
                padding: "10px",
                marginBottom: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                width: "80%",
              }}
            />
            <ProfileBio
              bio={newBio}
              editing={true}
              onChange={(value) => setNewBio(value)}
            />
            <button
              onClick={handleSave}
              style={{
                backgroundColor: "#dbd9d1",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                margin: "5px",
                color: "#333",
              }}
            >
              Save
            </button>
            <button
              onClick={handleCancel}
              style={{
                backgroundColor: "#cfccc7",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                margin: "5px",
              }}
            >
              Cancel
            </button>
          </>
        ) : (
          <>
            <ProfilePicture
              photo={user?.photo}
              name={user?.name}
              onEdit={handleEdit}
            />
            <ProfileBio bio={user?.email} editing={false} />
          </>
        )}
      </div>
      <button
        onClick={handleSignOut}
        className="sign-out-button"
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          backgroundColor: "#dbd9d1",
          color: "#333",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Sign Out
      </button>
    </div>
  );
};

export default ProfilePage;
